import { useEffect, useState } from "react";

import { useHistory, useRouteMatch } from "react-router-dom";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import { appInsights } from "../../../../../../config/appInsights";
import { IAccounts, IContactPerson } from "../../../../Interfaces";
import Paginator from "../../../../../Pagination/Pagination.component";
import { showModal } from "../../../../../../redux/actions/modal";
import { RootState } from "../../../../../../redux/store";

import styles from "./accountDetails.module.scss";
import { ROLE_TYPES } from "../../../../../../helpers/roleTypes";

interface IAccountDetailsProps {
  accounts: IAccounts[];
  contactPerson: IContactPerson;
}

const AccountDetails = ({ accounts, contactPerson }: IAccountDetailsProps) => {
  const [page, setPage] = useState(1);
  const [size, setPageSize] = useState(10);

  const match = useRouteMatch();
  const { id } = match?.params as { id: string };

  const history = useHistory();
  const dispatch = useDispatch();

  const { loggedInUser } = useSelector(
    (state: RootState) => state?.authReducer,
  );

  const handleCreateAccount = () => {
    dispatch(
      showModal({
        modalIdentifier: "createcustomerwallet",
        dataRecord: { funderId: Number(id) },
      }),
    );
  };

  useEffect(() => {
    appInsights.trackPageView({
      name: "AccountDetails.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="table-view speed-1x animated fadeInRight">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className={styles.title}>All Savings Account</h1>
        {loggedInUser &&
          loggedInUser?.roles.includes(
            ROLE_TYPES.CUSTOMER_WALLET_INITIATOR,
          ) && (
            <div className={`input-group ${styles.buttonGroup}`}>
              <button
                className="btn advancly-btn ml-2 form-control"
                onClick={handleCreateAccount}
              >
                Create Account
              </button>
            </div>
          )}
      </div>

      <div>
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Account Number</th>
                <th>Account Name</th>
                <th>Product</th>
                <th>Status</th>
                <th>Balance</th>
                <th>Last Active</th>
                <th>Action</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {accounts &&
                accounts
                  .slice((page - 1) * size, size * (page - 1) + size)
                  .map((data, _id: number) => {
                    const {
                      accountName,
                      accountNumber,
                      availableBalance,
                      lastActive,
                      product,
                      status,
                      walletId,
                      walletProvider,
                      walletProviderId,
                    } = data;
                    return (
                      <tr key={_id}>
                        <td>{_id + 1}</td>
                        <td>{accountNumber}</td>
                        <td>{accountName}</td>
                        <td>{product}</td>
                        <td>{status}</td>
                        <td>{availableBalance}</td>
                        <td>{lastActive}</td>
                        <td>
                          <span
                            className="color-mid-blue cursor-pointer font-weight-bold"
                            onClick={() => {
                              history.push({
                                pathname: `/db/business-customer/account-detail/${walletId}`,
                                state: {
                                  customerId: id,
                                  accountNumber,
                                  accountName,
                                  walletProvider,
                                  walletProviderId,
                                  ...contactPerson,
                                },
                              });
                            }}
                          >
                            {" "}
                            View Details
                          </span>
                        </td>
                      </tr>
                    );
                  })}
            </MDBTableBody>
          </MDBTable>
        </>

        <Paginator
          size={size}
          page={page}
          count={accounts && accounts.length - 1}
          changeCurrentPage={(pageNumber: number) => setPage(pageNumber)}
        />
      </div>
    </div>
  );
};

export default AccountDetails;
